import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentDepartureChecklist(enrollmentId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getEnrollmentDepartureChecklist.url, { id: enrollmentId })
    )
    .get<{ content: string }>()
}

export function getEnrollmentCanAccessDepartureChecklist(enrollmentId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getEnrollmentCanAccessDepartureChecklist.url, {
        id: enrollmentId
      })
    )
    .get<boolean>()
}
